<ng-template [ngIf]="gruppiCompetenti">
<div class="gruppi_competenza" *ngIf="!hideGroupAssegnazioneCompetenza(tipoFascicolo)">
	<h4 class="titlelevelcompetenza">Gruppi competenti</h4>
	<div class="row">
		<div class="col-sm-11 col-xs-10">
			<input type="text" placeholder="Cerca" aria-label="cerca gruppi competenti" class="form-control white"
				#searchItem (keyup)="0">
		</div>
		<div class="col-sm-1 col-xs-2 active singlecheckbox custom_check" style="display: flex; padding-top: 7px;">
			<span class="col-sm-11">
				<label class="fakelabel"></label>
			</span>
			<input name="gruppo_1" id="gruppo_1" value="value1" type="checkbox" [checked]="allGroupsFlag"
				(click)="onSelectAllGroups()" [disabled]="true">
			<label for="gruppo_1"> <small class="sr-only">Seleziona tutti gruppi competenti</small> </label>
		</div>
	</div>
	<!-- <form> -->
		<div class="row" style="margin-top: 20px;">
			<ul class="gruppi">
				<ng-template ngFor
					let-gruppo [ngForOf]="gruppiTerritoriali | searchFilter : searchItem.value : 'nomeGruppo'">
					<li>
						<div class="col-sm-12">
							<p class="active singlecheckbox">
								<span class="col-sm-11 col-xs-10"><label class="fakelabel">{{gruppo.nomeGruppo}}</label></span>
								<input class="col-xs-2 col-sm-1" name="{{ gruppo.id }}" id="{{ gruppo.id }}"	value="{{ gruppo.id }}"
									(click)="onSelectMultipleGroups($event, gruppo.id)"
									type="checkbox" [disabled]="!gruppo.active"
									[checked]="isPresente(gruppo.id) || allGroupsFlag || isCompetente(gruppo.id)">
									<label for="{{ gruppo.id }}"> <small class="sr-only">Seleziona gruppo {{gruppo.nomeGruppo}}</small></label>
							</p>
						</div>
					</li>
				</ng-template>
			</ul>
		</div>
	<!-- </form> -->
</div>
<div class="gruppi_competenza">
	<div class="utenti">
		<h4 class="titlelevelcompetenza">Utenti del gruppo {{ gruppoCompetente?.nomeGruppo }}</h4>
	</div>
	<!-- <form action="#"> -->
		<div class="row">
			<div class="col-sm-12 col-xs-12">
				<input type="text" placeholder="Cerca" class="form-control white" aria-label="cerca utenti" (keyup)="filterUtenti($event)">
			</div>

		</div>
		<div class="row">
			<div class="col-xs-12 col-sm-12" style="margin-top: 20px;">
				<table class="table template-utente">
					<caption class="sr-only">Tabella utenti assegnazione</caption>
					<thead>
						<tr>
							<th scope="col" class="col-xs-4">Utenti</th>
							<th scope="col" class="col-xs-4">Abilita come referente</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let user of listaUtenti">
							<td style="text-align: left;">
								<span class="col-sm-9"><label class="fakelabel">{{user.label }}</label></span>
							</td>
							<td style="text-align: center;">
								<p class="active singlecheckbox single_col radiobutton" style="margin: 0;">
									<input
										name="assegnatario" id="{{ user.id }}" value="{{ user.id }}"
										type="radio" (click)="onSelectUser.emit(user)" [checked]="user.id === utenteCompetente?.username">
									<label for="{{ user.id }}">
										<small class="sr-only">Seleziona utente {{user.label}}</small>
									</label>
								</p>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!-- <ul class="gruppi">
				<li>
					<div class="intestazione">
						<p class="col-sm-8 single_col">Utenti</p>
					</div>
					<div class="intestazione semibold">
						<p class="col-sm-4 single_col">Abilita come referente</p>
					</div>
				</li>
				<ng-template ngFor let-user [ngForOf]="listaUtenti">
				<li>
					<div class="col-sm-12">
						<p class="active singlecheckbox single_col radiobutton">
							<span class="col-sm-9"><label class="fakelabel">{{user.label }}</label></span>
							<input
								name="assegnatario" id="{{ user.id }}" value="{{ user.id }}"
								type="radio" (click)="onSelectUser.emit(user)" [checked]="user.id === utenteCompetente?.username"> <label
								for="{{ user.id }}">Abilita</label>
						</p>
					</div>
				</li>
				</ng-template>
			</ul> -->
		</div>
	<!-- </form> -->
</div>
</ng-template>
